const getInitialState = () => ({
    allowDebug: false,
    buildNum: 0,
    currentTheme: '',
    isPortrait: false,
    kwtMode: null,
    showDebug: false,
    device: {
        isChromeOS: false,
        isIOSApp: false,
        isInIframe: false,
        isModernBrowser: true,
        isMobile: false,
        usingExternalKeyboard: undefined
    },
    settings: {},
    theme: undefined,
    isLiteVersion: false,
    accessibilityMode: false,
    toolbarMode: undefined,
    modal: undefined,
    video: undefined
});
export default getInitialState;
